import { SagaIterator } from 'redux-saga';
import { takeEvery } from 'redux-saga/effects';

import { handleNewMetricForDatasourceAction } from './NewMetricForDatasourceSagas';
import { NewMetricForDatasource } from '../actions/NewMetricForDatasourceAction';

export function* rootMetricSaga(): SagaIterator {
  yield takeEvery(NewMetricForDatasource, handleNewMetricForDatasourceAction);
}
